import axios from 'axios';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Pusher = Pusher;

const defaultOptions = {
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
}

window.Echo = new Echo(defaultOptions);
window.WebsiteEcho = new Echo({
    ...defaultOptions,
    authEndpoint: `${import.meta.env.VITE_APP_URL}/chat/broadcasting/auth`,
    channelAuthorization: {
        endpoint: `${import.meta.env.VITE_APP_URL}/chat/broadcasting/auth`,
        params: {
            websiteUuid: localStorage.getItem('bestReplyChat-website'),
        }
    },
    auth: {
        params: {
            websiteUuid: localStorage.getItem('bestReplyChat-website'),
        }
    }
});
